import React, { useEffect } from 'react';
import { useConfig } from '../../config';
import { getAdConfig, getGaMeasurementId } from 'shared/util/adConfig';

const GA_SCRIPT_SRC = 'https://www.googletagmanager.com/gtag/js';

const GoogleAnalyticsLoader: React.FC = () => {
  const { config } = useConfig();

  useEffect(() => {
    const adConfig = getAdConfig(config as any);
    const measurementId = getGaMeasurementId(adConfig);
    if (!measurementId) return;

    const existing = document.querySelector(`script[data-ga-id="${measurementId}"]`);
    if (existing) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `${GA_SCRIPT_SRC}?id=${measurementId}`;
    script.setAttribute('data-ga-id', measurementId);
    document.head.appendChild(script);

    const inline = document.createElement('script');
    inline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);} 
      gtag('js', new Date());
      gtag('config', '${measurementId}');
    `;
    document.head.appendChild(inline);

    return () => {
      // do not remove scripts on unmount to avoid reinitialization churn during route changes
    };
  }, [config]);

  return null;
};

export default GoogleAnalyticsLoader;


